import 'react-datepicker/dist/react-datepicker.css'

import { endOfDay } from 'date-fns/endOfDay'
import { parseISO } from 'date-fns/parseISO'
import React from 'react'
import DatePicker from 'react-datepicker'

import { Button } from '@/components/ui/button'
import { ButtonGroup } from '@/components/ui/button-group'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import {
  DATE_FORMATS,
  REFERRAL_IMPORT_DIRECTION,
  REFERRAL_SOURCE,
} from '@/lib/constants'
import { cn } from '@/lib/utils'
import {
  selectIsLoggingReceivedReferral,
  selectIsLoggingSentReferral,
  selectLogHistoricalReferralState,
  updateLogData,
} from '@/redux/slices/logHistoricalReferral'

interface Props {
  className?: string
  disabled?: boolean
}

const SelectDirectionAndDate: React.FC<Props> = ({
  className,
  disabled = false,
}) => {
  const referralLogHistoricalState = useAppSelector(
    selectLogHistoricalReferralState,
  )
  const isLoggingSentReferral = useAppSelector(selectIsLoggingSentReferral)
  const isLoggingReceivedReferral = useAppSelector(
    selectIsLoggingReceivedReferral,
  )
  const dispatch = useAppDispatch()
  const endOfToday = endOfDay(new Date())

  function handleSelectSentDirection() {
    dispatch(
      updateLogData({
        referralDirection: REFERRAL_IMPORT_DIRECTION.TO,
        newServiceAreaId: null,
        serviceAreaId: -1,
        // A sent referral can only have the 'Introducer' type
        referralSource: REFERRAL_SOURCE.INTRODUCER,
      }),
    )
  }

  function handleSelectReceivedDirection() {
    dispatch(
      updateLogData({
        referralDirection: REFERRAL_IMPORT_DIRECTION.FROM,
        newServiceAreaId: null,
        serviceAreaId: -1,
      }),
    )
  }

  return (
    <div
      className={cn(
        'flex flex-col sm:flex-row sm:items-center gap-y-2 gap-x-3',
        className,
      )}
    >
      <ButtonGroup>
        <Button
          disabled={disabled}
          variant={isLoggingSentReferral ? 'primary' : 'outline'}
          className="text-[13px]"
          onClick={handleSelectSentDirection}
        >
          Sent
        </Button>

        <Button
          disabled={disabled}
          variant={isLoggingReceivedReferral ? 'primary' : 'outline'}
          className="text-[13px]"
          onClick={handleSelectReceivedDirection}
        >
          Received
        </Button>
      </ButtonGroup>

      <div className="text-muted-foreground hidden sm:block">on</div>

      <DatePicker
        disabled={disabled}
        selected={
          referralLogHistoricalState.logData.dateReferred
            ? parseISO(referralLogHistoricalState.logData.dateReferred)
            : undefined
        }
        onChange={(newDate) =>
          dispatch(
            updateLogData({
              dateReferred: newDate ? newDate.toISOString() : '',
            }),
          )
        }
        maxDate={endOfToday}
        placeholderText="Select date"
        dateFormat={DATE_FORMATS.DAY_MONTH_YEAR}
        className="input w-full sm:max-w-27.5"
      />
    </div>
  )
}

export default SelectDirectionAndDate
